export default __webpack_public_path__ + "static/media/3072.a08cee73.jpg";